module.exports = __webpack_public_path__ + "media/src/images/step3-995a24f764946fe9b3701cd92e327b0b.png";